import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore';
import { AppStore, GoodsCat, RecordList } from '../types';
import { apiGetGoodsCatList } from '../api';

// 请求成功时传送的参数
interface SuccessParams {
  list: Array<GoodsCat>;
}
// 请求失败时传送的参数
interface FailureParams {
  error: string;
}

const goodsCatSlice = createSlice({
  name: 'goodsCat',
  initialState: { fetching: false, loaded: false } as RecordList<GoodsCat>,
  reducers: {
    goodsCatRequest: (state: RecordList<GoodsCat>, action: PayloadAction) => {
      state.fetching = true;
      return state;
    },
    goodsCatSuccess: (state: RecordList<GoodsCat>, action: PayloadAction<SuccessParams>) => {
      state.fetching = false;
      state.loaded = true;
      state.results = action.payload.list;
      return state;
    },
    goodsCatFailure: (state: RecordList<GoodsCat>, action: PayloadAction<FailureParams>) => {
      state.fetching = false;
      state.loaded = true;
      state.error = action.payload.error;
      return state;
    },
    goodsCatClear: (state: RecordList<GoodsCat>) => {
      state = { fetching: false, loaded: false } as RecordList<GoodsCat>;
      return state;
    },
  },
});

export const { goodsCatRequest, goodsCatSuccess, goodsCatFailure, goodsCatClear } = goodsCatSlice.actions;
export default goodsCatSlice.reducer;

export const goodsCatEffect = {
  'goodsCat/clear': (store: ToolkitStore<AppStore>) => store.dispatch(goodsCatClear()),
  'goodsCat/goodsCatRequest': async (store: ToolkitStore<AppStore>, action: PayloadAction) => {
    let list = store.getState().goodsCat;
    if (list?.loaded === true && !list?.error) {
      store.dispatch(goodsCatSuccess({ list: list.results ?? [] }));
    } else {
      try {
        let res = await apiGetGoodsCatList();
        let data = res.data;
        if (data.code === 200) {
          store.dispatch(goodsCatSuccess({ list: data.data }));
        } else {
          store.dispatch(goodsCatFailure({ error: data.msg || '获取失败' }));
        }
      } catch (e: any) {
        store.dispatch(goodsCatFailure({ error: e.toString() || '获取失败' }));
      }
    }
  },
};
